(() => {
  'use strict';
  const media = window.matchMedia('(max-width:989px)');
  const path = value => { try { return new URL(value, location.origin).pathname; } catch { return ''; } };
  const lines = value => String(value || '').split(/\r?\n/).map(s => s.trim()).filter(Boolean);
  const safeUrl = value => {
    if (!String(value || '').trim()) return null;
    try { const u = new URL(String(value || '').trim(), location.origin); return /^(https?:)$/.test(u.protocol) ? u.href : null; } catch { return null; }
  };
  const read = node => { try { return JSON.parse(node?.textContent || '{}'); } catch { return {}; } };
  const managedKey = value => { try { const u = new URL(value, location.origin); return u.pathname + (u.hash.startsWith('#ct-label-') ? u.hash : ''); } catch { return ''; } };
  function managedLinks(entry, managed) {
    const key = managedKey(entry.dataset.menuUrl), set = managed.sets?.[key];
    if (set?.mode === 'none') return [];
    const explicit = entry.querySelector('.ct-native-children');
    if (!set && explicit) return read(explicit);
    if (!set && !/^\/collections\/[^/]+\/?$/.test(key)) return [];
    const pattern = managed.patterns?.[set?.mode === 'custom' ? set.pattern : managed.defaultPattern] || [];
    return pattern.map(link => ({ text: link.text, url: link.url.replace(/^\{collection\}/, key) })).filter(link => link.text && safeUrl(link.url));
  }
  function iconFor(entry, game, config) {
    if (config.managed?.version === 3) return safeUrl(config.managed.sets?.[managedKey(entry.dataset.menuUrl)]?.image || '');
    const collectionPath = path(entry.dataset.menuUrl), title = entry.dataset.menuTitle;
    const candidates = (game.legacy || []).filter(v => path(v.url) === collectionPath);
    const legacy = candidates.find(v => v.title === title) || (candidates.length === 1 ? candidates[0] : null);
    let icon = legacy?.image || '';
    for (const rule of config.rules || []) {
      if (rule.type !== 'set_rule' || !rule.collection || path(rule.collection) !== collectionPath || (rule.item_title && rule.item_title !== title)) continue;
      if (rule.icon) icon = rule.icon;
      if (rule.hide_icon) icon = '';
    }
    return safeUrl(icon);
  }
  function entryLabel(entry, game, config) {
    const label = document.createElement('span'); label.className = 'ct-entry-label';
    const icon = iconFor(entry, game, config);
    if (icon) { const img = document.createElement('img'); img.className = 'ct-set-icon'; img.src = icon; img.alt = ''; img.width = img.height = 24; img.loading = 'lazy'; label.append(img); }
    const text = document.createElement('span'); text.textContent = entry.dataset.menuTitle; label.append(text); return label;
  }
  function linksFor(entry, game, config) {
    if (config.managed?.version === 3) return managedLinks(entry, config.managed);
    const url = entry.dataset.menuUrl, title = entry.dataset.menuTitle;
    const collectionPath = path(url), isCollection = /^\/collections\/[^/]+\/?$/.test(collectionPath);
    const candidates = (game.legacy || []).filter(v => path(v.url) === collectionPath);
    const legacy = candidates.find(v => v.title === title) || (candidates.length === 1 ? candidates[0] : null);
    const explicit = entry.querySelector('.ct-native-children');
    let links;
    const fromProfile = id => id === 'none' || !isCollection ? [] : (game.profiles[id]?.links || game.profiles.default?.links || []).map(v => ({ text: v.text, url: collectionPath + v.suffix }));
    if (explicit) links = read(explicit);
    else if (legacy) links = legacy.links.map(v => ({ ...v }));
    else links = fromProfile(config.profile || 'default');
    if (!Array.isArray(links)) links = [];
    const matching = (config.rules || []).filter(r => r.collection && path(r.collection) === collectionPath && (!r.item_title || r.item_title === title));
    for (const rule of matching.filter(r => r.type === 'set_rule')) {
      if (rule.profile && rule.profile !== 'inherit') links = fromProfile(rule.profile);
      const hidden = lines(rule.hide_labels); links = links.filter(l => !hidden.includes(l.text));
    }
    for (const rule of matching.filter(r => r.type === 'custom_link')) {
      const label = (rule.title || '').trim(); if (!label) continue;
      const index = links.findIndex(l => l.text === label);
      if (rule.operation === 'hide') { links = links.filter(l => l.text !== label); continue; }
      const href = safeUrl(rule.url); if (!href) continue;
      const replacement = { text: label, url: href };
      if (rule.operation !== 'add' && index >= 0) links[index] = replacement;
      else { const before = links.findIndex(l => l.text === (rule.before || '全て表示')); links.splice(before >= 0 ? before : links.length, 0, replacement); }
    }
    return links.filter(l => l.text && safeUrl(l.url));
  }
  function populate(nav) {
    const game = window.CantripMenuData?.games?.[nav.dataset.game] || {legacy: [], profiles: {}};
    const config = read(nav.querySelector('.ct-menu-config'));
    config.managed = read(nav.querySelector('.ct-menu-managed'));
    nav.querySelectorAll('.ct-menu-entry:not([data-ready])').forEach(entry => {
      const links = linksFor(entry, game, config); entry.dataset.ready = 'true';
      if (!links.length) {
        if (managedKey(entry.dataset.menuUrl).includes('#ct-label-')) {
          const label = document.createElement('span'); label.className = 'ct-nav-direct ct-nav-label';
          label.append(entryLabel(entry, game, config)); entry.replaceChildren(label); return;
        }
        const legacy = game.legacy.find(v => v.title === entry.dataset.menuTitle && path(v.url) === path(entry.dataset.menuUrl));
        if (config.managed?.version !== 3 && legacy && safeUrl(legacy.url)) entry.querySelector('a').href = safeUrl(legacy.url);
        entry.querySelector('a').replaceChildren(entryLabel(entry, game, config));
        return;
      }
      const details = document.createElement('details'); details.className = 'ct-nav-set';
      const summary = document.createElement('summary');
      const label = entryLabel(entry, game, config);
      const chevron = document.createElement('span'); chevron.className = 'ct-nav-chevron'; chevron.setAttribute('aria-hidden', 'true'); summary.append(label, chevron);
      const list = document.createElement('ul'); list.className = 'ct-nav-children'; list.setAttribute('role', 'list');
      for (const link of links) { const li = document.createElement('li'), a = document.createElement('a'); a.href = safeUrl(link.url); a.textContent = link.text; li.append(a); list.append(li); }
      details.append(summary, list); entry.replaceChildren(details);
    });
  }
  function choices() {
    const templates = [...document.querySelectorAll('template.ct-title-choice')];
    const mode = document.getElementById('ct-navigation-options')?.dataset.titleChoiceMode || 'banner';
    document.querySelectorAll('.ct-title-choices').forEach(list => { list.dataset.display = mode; list.replaceChildren(); for (const template of templates) { const li = document.createElement('li'); li.append(template.content.cloneNode(true)); list.append(li); } });
  }
  function position() {
    const home = document.getElementById('cantrip-navigation-home'), nav = document.getElementById('cantrip-navigation'), mobile = document.getElementById('cantrip-navigation-mobile');
    const target = media.matches && mobile ? mobile : home;
    if (nav && target && nav.parentElement !== target) target.append(nav);
    const tools = document.querySelector('.ct-title-tools'), header = document.getElementById('cantrip-header-title');
    if (tools && header) { if (tools.parentElement !== header) header.append(tools); tools.hidden = false; }
    const logo = document.getElementById('move_header__heading'), mobileLogo = document.getElementById('sp-header-move-area');
    if (logo && mobileLogo && !mobileLogo.querySelector('.header__heading-link')) { const copy = logo.cloneNode(true); copy.removeAttribute('id'); mobileLogo.replaceChildren(copy); }
  }
  function init() { position(); document.querySelectorAll('.ct-navigation-v2').forEach(populate); choices(); }
  document.addEventListener('click', event => {
    const summary = event.target.closest('.ct-nav-group > summary, .ct-nav-set > summary');
    if (!summary || summary.parentElement.open) return;
    const item = summary.closest('.ct-nav-item');
    if (!item) return;
    for (const sibling of item.parentElement.children) {
      if (sibling === item) continue;
      const details = sibling.querySelector(':scope > details.ct-nav-group, :scope > .ct-menu-entry > details.ct-nav-set');
      if (details) details.open = false;
    }
  });
  document.addEventListener('click', event => { document.querySelectorAll('.ct-title-picker[open]').forEach(picker => { if (!picker.contains(event.target)) picker.open = false; }); });
  document.addEventListener('keydown', event => { if (event.key !== 'Escape') return; document.querySelectorAll('.ct-title-picker[open],.ct-mobile-title-picker[open]').forEach(picker => { picker.open = false; picker.querySelector('summary')?.focus(); }); });
  document.addEventListener('shopify:section:unload', event => { const home = event.target.querySelector('[data-title-section]'); if (home) { document.querySelector('.ct-title-tools')?.remove(); document.querySelector('.ct-navigation-v2')?.remove(); } });
  document.addEventListener('shopify:section:load', init); media.addEventListener('change', position);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
